import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
    fetchEstadosLiquidaciones,
    fetchLiquidacionesBusqueda,
    limpiarLiquidacionesBusqueda
} from '../../../../actions/LiquidacionesActions';
import { 
    getLiquidacionesListaSellers, 
    getEstadosLiquidacionesCorrecto,
    putEliminaLiquidacionFinal
} from '../../../../api/axios.js';
import { fetchLiquidacionesListaSellers } from '../../../../actions/sellersActions';
import LiquidacionesListItems from './LiquidacionesListItems';
import { DropDownArrow, EstiloCombos } from "../../../../template/CustomStyle";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Spinner } from 'react-bootstrap';
import { filtroMedioMes } from '../../../../utilities/fechasFiltro';

const fechaFiltro = filtroMedioMes();

class ListLiquidaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lista_sellers_liquidaciones: [],
            lista_estados_liquidaciones: [],
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesdeSesenta: "",
            request: {
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                buscaTodo: false,
                idEstado: 0,
                cantidadPagina: 10,
                numeroPagina: 1
            }
        }
    };

    componentDidMount() {

        this.props.limpiarLiquidacionesBusqueda();

        /*CARGA DE SELLERS*/
        const cargasellers = getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            });
            this.setState({ lista_sellers_liquidaciones: listaTipo });
        });

        /*CARGA DE ESTADOS*/
        const cargaestados = getEstadosLiquidacionesCorrecto().then(res_estados => {
            let listaEstado = res_estados.listadoEstadosLiquidaciones.map((tipo) => {
                return { label: tipo.descripcion, value: tipo.idEstado.toString() };
            });           
            this.setState({ lista_estados_liquidaciones: listaEstado });
        });

        let fechaSesenta = new Date();
        fechaSesenta.setDate(fechaSesenta.getDate() - 360);

        this.setState({ fechaDesdeSesenta: fechaSesenta.toISOString().slice(0, 10) });
    }

    onLiquidacion = (idSeller, idLiquidacion) => {
        this.props.history.push(`/Liquidaciones/Editar/${idLiquidacion}/${idSeller}`);
    }

    onLiquidacionEditable = (idSeller, idLiquidacion) => {
        this.props.history.push(`/Liquidaciones/EditarBorrador/${idLiquidacion}/${idSeller}`);
    }

    goToCrearLiquidacion = () => {
        this.props.history.push("/Liquidaciones/Nueva");
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ request: { ...this.state.request, [name]: value } });
    }

    onChangeCheckbox = async (e) => {
        const { name, checked } = e.target;
        this.setState({ request: { ...this.state.request, [name]: checked } });
    }

    eliminarLiquidacion = (idLiquidacion) => {
        
        let request = {IdLiquidacion: idLiquidacion};
        let post = putEliminaLiquidacionFinal(request);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("La liquidación fue eliminada con éxito");
        }).catch(err => {
            toast.error("No pudimos eliminar la liquidación");
        });
    }

    onSubmit = (event) => {

        event.preventDefault();

        let request = { ...this.state.request };

        if (request.fechaDesde == "") {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }

        if (request.fechaHasta == "") {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        if (request.buscaTodo) {
            request.buscaTodo = 1;
            request.idSeller = 0;
            request.idEstado = 0;
        } else {
            if (this.state.comboLiquidacionSeller.value == "") {
                toast.warn("Seleccione un Seller");
                return;
            };

            if (this.state.comboLiquidacionEstado.value == "") {
                toast.warn("Seleccione un Estado");
                return;
            };

            request.buscaTodo = 0;
            request.idSeller = this.state.comboLiquidacionSeller.value;
            request.idEstado = this.state.comboLiquidacionEstado.value;
        }

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchLiquidacionesBusqueda(request);
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({comboLiquidacionSeller: valor});
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionEstado: valor });
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return {label: tipo.razonSocial, value: tipo.codigo.toString()};
            });
            this.setState({lista_sellers_liquidaciones: listaTipo});
        })
    }

    mapEstados = () => {

        getEstadosLiquidacionesCorrecto().then(res_estados => {
            let listaEstado = res_estados.listadoEstadosLiquidaciones.map((tipo) => {
                return { label: tipo.descripcion, value: tipo.idEstado.toString() };
            })
            this.setState({
                lista_estados_liquidaciones: listaEstado
            })
        });
    }


    render() {

        let liquidaciones = !Array.isArray(this.props.liquidaciones) ? [] : this.props.liquidaciones;

        return (
            <div className="container">
                <div className="row justify-content-between">

                    <div className="col-12 col-md-4">
                        <h4 className="text-themecolor color-rojo-megatone">Gestión de Liquidación</h4>
                    </div>

                    <div className="col-12 col-md-2 text-end">
                        <button 
                            onClick={this.goToCrearLiquidacion} 
                            type="button" 
                            className="btn btn-sm btn-green"
                        >
                            Crear Liquidación
                        </button>
                    </div>

                    <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                        <div className="card">
                            <div className="card-body p-4">

                                <div className="row justify-content-between">
                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Desde</p>
                                        <input 
                                            type="date" 
                                            name="fechaDesde"
                                            className="form-control" 
                                            onChange={this.myChangeHandler}
                                            min={this.state.fechaDesdeSesenta} 
                                            value={this.state.request.fechaDesde}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">
                                        <p className="font-bold">Hasta</p>
                                        <input 
                                            type="date" 
                                            name="fechaHasta" 
                                            className="form-control" 
                                            onChange={this.myChangeHandler}
                                            min={this.state.fechaDesdeSesenta} 
                                            value={this.state.request.fechaHasta} 
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Seller</p>
                                        <Select
                                            value={this.state.comboLiquidacionSeller}
                                            options={this.state.lista_sellers_liquidaciones}
                                            onChange={this.selectSearchHandlerLiquidacionesSeller}
                                            onMenuOpen={this.mapSellers}
                                            styles={EstiloCombos}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Estados</p>
                                        <Select
                                            value={{ 
                                                label: this.state.comboLiquidacionEstado.label, 
                                                value: this.state.comboLiquidacionEstado.value
                                            }}
                                            options={this.state.lista_estados_liquidaciones}
                                            onChange={this.selectSearchHandlerLiquidacionesEstado}
                                            onMenuOpen={this.mapEstados}
                                            styles={EstiloCombos}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                        />
                                    </div>

                                    <div className="col-12 col-md-8 d-inline-block mt-4">
                                        <input 
                                            name="buscaTodo"
                                            type="checkbox" 
                                            className="mx-2"
                                            onChange={this.onChangeCheckbox}
                                        />
                                        <label htmlFor="BuscaTodo">
                                            Todas las liquidaciones de todos los sellers en el rango de tiempo
                                        </label>
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block mt-4 text-end">
                                        <button 
                                            type="submit" 
                                            id="botonBuscar" 
                                            className="btn btn-sm background-rojo-megatone"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Buscar
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>

                    <div hidden={!this.props.isLoadingLiquidaciones}>
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner>
                        </div>
                    </div>

                    <div className="container" hidden={this.props.isLoadingLiquidaciones}>
                    {
                        liquidaciones.length === 0 ? 

                        <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                            NO SE ENCONTRARON RESULTADOS
                        </h5>

                        : 

                        <LiquidacionesListItems 
                            liquidaciones={liquidaciones} 
                            onLiquidacionFunction={this.onLiquidacion} 
                            onLiquidacionEditableFunction={this.onLiquidacionEditable} 
                            eliminarLiquidacionFunction={this.eliminarLiquidacion}
                        />
                    }
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
    liquidaciones: state.liquidaciones.lista_liquidaciones_busqueda,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones
});

export default connect(mapStateToProps, {
    fetchLiquidacionesListaSellers,
    limpiarLiquidacionesBusqueda,
    fetchLiquidacionesBusqueda,
    fetchEstadosLiquidaciones
}) (ListLiquidaciones);